/** @format */

import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { toggleSidebar } from "../../Redux/Layout/layoutSlice";

const NavItem = ({ icon, title, href }) => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery('(max-width:900px)');
  const isActive = pathname === href;

  return (
    href.startsWith("http") ? (
      <a
        href={href}
        rel="noopener noreferrer"
        onClick={() => isMobile && dispatch(toggleSidebar())}
        className={`flex mb-2 mx-2 rounded-3xl transition-all duration-300 hover:!bg-[#613377]`}
      >
        <ListItemButton className="!py-1">
          <ListItemIcon sx={{ minWidth: "50px" }}>{icon}</ListItemIcon>
          <ListItemText disableTypography primary={title} sx={{ fontSize: "1rem" }} />
        </ListItemButton>
      </a>
    ) : (
      <Link
        to={href}
        onClick={() => isMobile && dispatch(toggleSidebar())}
        className={`flex mb-2 mx-2 rounded-3xl transition-all duration-300 hover:!bg-[#613377] ${
          isActive ? "!bg-[#613377]" : ""
        }`}
      >
        <ListItemButton className="!py-1">
          <ListItemIcon sx={{ minWidth: "50px" }}>{icon}</ListItemIcon>
          <ListItemText disableTypography primary={title} sx={{ fontSize: "1rem" }} />
        </ListItemButton>
      </Link>
    )
  );
};

export default NavItem;
